import React from "react";
import { FaFacebook, FaInstagram, FaYoutube } from "react-icons/fa6";
import { HiMail } from "react-icons/hi";

export const Gigs = () => {
  return (
    <div>
      <div className=" text-white text-center my-6">
        <h1 className="text-3xl sm:text-4xl font-bold text-srs-pink">
          Upcoming Gigs
        </h1>
        <div className="flex justify-center my-5">
          <div className="space-y-4 text-left">
            
            <div className="flex gap-6 sm:gap-56 justify-between items-center pb-10 mt-5">
              <div>
                <p className="text-2xl sm:text-3xl font-semibold">Glasgow</p>
                <p className="text-lg sm:text-xl text-srs-pink">The Garage</p>
              </div>
              <div>
                <div className="flex-col justify-center text-center ">
                  <p className="text-xl text-white">Jan 20</p>
                  <a href="#" className="text-srs-pink hover:underline">
                  <button className="bg-srs-pink hover:scale-105 duration-100 ease-in-out hover:bg-srs-orange text-white text-sm sm:text-lg font-bold py-2 px-2 sm:px-4 rounded-full">
                    Buy Tickets
                  </button>
                  </a>
                </div>
              </div>
            </div>

            <div className="flex gap-6 sm:gap-56 justify-between items-center pb-10">
              <div>
                <p className="text-2xl sm:text-3xl font-semibold">Edinburgh</p>
                <p className="text-lg sm:text-xl text-srs-pink">O2 Academy</p>
              </div>
              <div>
                <div className="flex-col justify-center text-center">
                  <p className="text-xl text-white">Jan 22</p>
                  <a href="#" className="text-srs-pink hover:underline">
                  <button className="bg-srs-pink hover:scale-105 duration-100 ease-in-out hover:bg-srs-orange text-white text-sm sm:text-lg font-bold py-2 px-2 sm:px-4 rounded-full">
                    Buy Tickets
                  </button>
                  </a>
                </div>
              </div>
            </div>

            <div className="flex gap-6 sm:gap-56 justify-between items-center pb-10">
              <div>
                <p className="text-2xl sm:text-3xl font-semibold">London</p>
                <p className="text-lg sm:text-xl text-srs-pink">London Eye</p>
              </div>
              <div className="flex-col justify-center text-center">
                <p className="text-xl text-white">Jan 31</p>
                <a href="#" className="text-srs-pink hover:underline">
                  <button className="bg-srs-pink hover:scale-105 ease-in-out duration-100 hover:bg-srs-orange text-white text-sm sm:text-lg font-bold py-2 px-2 sm:px-4 rounded-full">
                    Buy Tickets
                  </button>
                </a>
              </div>
            </div>

          </div>
        </div>
      </div>
      
      <div>
        <svg className="" viewBox="0 0 1440 106" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0 28.8459L60 20.5216C120 12.1974 240 -4.4511 360 1.11574C480 6.47447 600 34.5688 720 37.1701C840 39.7715 960 17.9203 1080 12.1974C1200 6.47447 1320 17.9203 1380 23.2791L1440 28.8459V94H1380C1320 94 1200 94 1080 94C960 94 840 94 720 94C600 94 480 94 360 94C240 94 120 94 60 94H0V28.8459Z" fill="#FF87B0"/>
          <path d="M0 41.5635L60 33.2393C120 24.915 240 8.26655 360 13.8334C480 19.1921 600 47.2865 720 49.8878C840 52.4891 960 30.638 1080 24.915C1200 19.1921 1320 30.638 1380 35.9967L1440 41.5635V98.5H1380C1320 98.5 1200 98.5 1080 98.5C960 98.5 840 98.5 720 98.5C600 98.5 480 98.5 360 98.5C240 98.5 120 98.5 60 98.5H0V41.5635Z" fill="#FFACA3"/>
          <path d="M0 58.6805L60 50.3712C120 42.062 240 25.4434 360 31.0002C480 36.3493 600 64.3932 720 66.9898C840 69.5865 960 47.7746 1080 42.062C1200 36.3493 1320 47.7746 1380 53.1237L1440 58.6805V98.5H1380C1320 98.5 1200 98.5 1080 98.5C960 98.5 840 98.5 720 98.5C600 98.5 480 98.5 360 98.5C240 98.5 120 98.5 60 98.5H0V58.6805Z" fill="#8747D1"/>
          <path d="M0 74.2885L60 65.9792C120 57.6699 240 41.0513 360 46.6081C480 51.9572 600 80.0011 720 82.5977C840 85.1944 960 63.3825 1080 57.6699C1200 51.9572 1320 63.3825 1380 68.7316L1440 74.2885V105.5H1380C1320 105.5 1200 105.5 1080 105.5C960 105.5 840 105.5 720 105.5C600 105.5 480 105.5 360 105.5C240 105.5 120 105.5 60 105.5H0V74.2885Z" fill="#6236FF"/>
        </svg>
      </div>


    </div>
  );
};

export default Gigs;
